<template>
  <div>
    <popUpLogSheet v-if="popUpWindow" :header="PopUpheader" @close="popUpWindow = val"></popUpLogSheet>
    <div class="logsheetHeader">
      <div class="headerContent">
        <span>Paylief</span>
      </div>
      <v-divider vertical></v-divider>
      <v-spacer />
      <div class="headerLogo">
        <img src="@/assets/user@2x.png" class="img-user-account cursor" />
      </div>
      <v-spacer />
    </div>
    <div class="logsheetBody">
      <div class="logsheetSideNav">
        <div class="listHeader">Categories</div>
        <!-- <ul>
          <li>Application Name</li>
          <li>Tag Name</li>
        </ul> -->
        <div class="selctionNav">
          <div :class= "openDropDown?'headerLabelActive':'headerLabel'" >{{ headerNav[0]}} <img @click="()=> openDropDown= !openDropDown " class="arrowDropDown" src="@/assets/path-2-copy.png" /></div>
         <div v-if="openDropDown">
          <div v-for="(optionLable, inde) in applicationName" :key="inde">
             <div ><input type="checkbox" @change="(bool)=>(selectedApplicationNames(bool,optionLable))"/>{{ optionLable}}</div>
             <div v-if="inde < applicationName.length-1" class="verticalLine"></div>
          </div>
         </div>
        </div>
        <div class="selctionNav">
          <div :class= "openDropDownTwo?'headerLabelActive':'headerLabel'" >{{ headerNav[1]}} <img @click="()=> openDropDownTwo= !openDropDownTwo " class="arrowDropDown" src="@/assets/path-2-copy.png" /></div>
         <div v-if="openDropDownTwo">
          <div v-for="(optionLable, index) in applicvationTagName" :key="index">
             <div >
              <input type="checkbox" @change="(bool)=>(selectedTagNames(bool,optionLable))"/>
              {{ optionLable}}</div>
             <div v-if="index < applicvationTagName.length-1" class="verticalLine"></div>
          </div>
         </div>
        </div>
        <btn
          class="button"
          text="Apply Filter"
          type="secondary"
          @click="fetchLogMangementBasedOnApplicationName()"
        />
        <div class="listHeaderLogType">Log Type</div>
        <ul>
          <li >Audit</li>
          <li >Expectation</li>
        </ul>
      </div>
     <div class="bodyContent">
        <div class="upperContent">
            <date-picker v-model="DateValue" formatDate="yyyy-MMM-dd" @datevalue="(val)=>DateValue=val" class="date-picker"></date-picker>
            <search-dropdown  placeholder="Search Employee"/>
        </div>
        <div class="bodyDataContent">
          <data-table-log-sheet :columnData="tableColumn" :tableDataRecord="tableData">
            <template v-slot="slotprops">
            <p v-if="slotprops.value.column.key =='dataTime'">{{ (slotprops.value.record.createdAt).split('T')[0]}}</p>
            <p class="highLightedText" v-if="slotprops.value.column.key =='dataTime'">{{(slotprops.value.record.createdAt).split(/[T .]+/).slice(0,2)[1] }}</p>
            <p  class="highLightedText" v-if="slotprops.value.column.key =='logMessageParticles'">Tag Name : {{ slotprops.value.record.tagName }}</p>
            <div v-if="slotprops.value.column.key =='logMessageParticles'">
              <p v-if="slotprops.value.record.exceptionLog">{{ slotprops.value.record.exceptionLog.logMessage }}</p>
              <p v-if="!slotprops.value.record.exceptionLog">{{ slotprops.value.record.auditLog.logMessage}}</p>
            </div>
                <btn
                  disabled
                  v-if="slotprops.value.column.key == 'logTypeStatus'"
                  :text='slotprops.value.record.logStatus ? "Audit" : "Exception"'
                  type="secondary"
                />
            <span v-if="slotprops.value.column.key == 'details'"><img class="arrowIcon" src="@/assets/path-2-copy.png" @click="popUpWindowFunction(slotprops.value.record)" /></span>
            </template>
          </data-table-log-sheet>
        </div>
        <div class="tableContent"></div>
     </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import popUpLogSheet from './popUpLogSheet.vue';
export default {
  components: { popUpLogSheet},
  data() {
    return {
      selectedApplicationArray:[],
      selectedTagArray:[],
      openDropDown: false,
      openDropDownTwo:false,
      popUpWindow: false,
      PopUpheader: "",
      optionNav:{
        "Application Name":[{lable:"Tag_1",flag:true},{lable:"Tag_2",flag:true},{lable:"Tag_3",flag:true},{lable:"Tag_4",flag:true}],
        "Tag Name":[{lable:"Tag_1",flag:true},{lable:"Tag_2 ",flag:true},{lable:"Tag_3",flag:true},{lable:"Tag_4",flag:true}]
      },
      headerNav:[
        "Application Name",
        "Tag Name"
      ],
      tableColumn:[
          { lable:"Date Time",
            key:"dataTime"
          },
          { lable:"Log Message Particles",
            key:"logMessageParticles"
          },
          { lable:"Log Type Status",
            key:"logTypeStatus"
          },
          {
            lable:"Details",
            key:"details"
          }
         ],
         tableData:[],
         applicationName:[],
         applicvationTagName:[],
         DateValue:""
    };
  },
  
  mounted() {
      this.fetchLogManahementDetails()
      this.fetchLogManahementApplicationDetails()
    },
  // activated(){
  //   this.fetchLogManahementDetails()
  // },
  methods:{
   ...mapActions({
      act_log_management_Details:
        "dashboard/logsheetManagement/fetchLogManagmentDetails",
      act_log_management_Application_Details:
        "dashboard/logsheetManagement/fetchLogManagmentApplicationDetails",
      act_log_management_Details_Application_Name:
        "dashboard/logsheetManagement/fetchLogManagmentDetailsOnApplicationName",
      act_log_management_details_tag_name:
        "dashboard/logsheetManagement/fetchLogManagmentDetailsOnTagName",
      act_log_management_details_both_app_tag:
        "dashboard/logsheetManagement/fetchLogManagmentDetailsOnBothAppTag",
      act_log_management_details_date:
        "dashboard/logsheetManagement/fetchLogManagmentDetailsOnDate",
    }),
    //function to FilterApplicationName When checkbox checked
    async selectedApplicationNames(value,record){
     let val=value.target.checked
     if(val == true){
      let checkRecordIncludes=this.selectedApplicationArray.includes(record)
      if(checkRecordIncludes == true){
        let ApplicationNamefilterdArrayTrue=this.selectedApplicationArray.filter((element)=>
        {
          return record != element
        })
        this.selectedApplicationArray = ApplicationNamefilterdArrayTrue
        this.selectedApplicationArray.push(record)
      }
      else{
      this.selectedApplicationArray.push(record)
      }
     }else{
      let ApplicationNamefilterdArrayFalse=this.selectedApplicationArray.filter((element)=>
        {
          return record != element
        })
        this.selectedApplicationArray = ApplicationNamefilterdArrayFalse
     }

    },
    async selectedTagNames(value,record){
     let val=value.target.checked
     if(val == true){
      let checkRecordIncludes=this.selectedTagArray.includes(record)
      if(checkRecordIncludes == true){
        let ApplicationNamefilterdArrayTrue=this.selectedTagArray.filter((element)=>
        {
          return record != element
        })
        this.selectedTagArray = ApplicationNamefilterdArrayTrue
        this.selectedTagArray.push(record)
      }
      else{
      this.selectedTagArray.push(record)
      }
     }else{
      let ApplicationNamefilterdArrayFalse=this.selectedTagArray.filter((element)=>
        {
          return record != element
        })
        this.selectedTagArray = ApplicationNamefilterdArrayFalse
     }

    },
    async fetchLogMangementBasedOnApplicationName(){
      try{
        if(this.selectedApplicationArray.length != 0 && this.selectedTagArray.length != 0){
        let payload={
          applicationName :this.selectedApplicationArray,
          tagName : this.selectedTagArray
        }
        let res = await this.act_log_management_details_both_app_tag(payload)
        console.log(res)
      }else if(this.selectedTagArray.length != 0){
        console.log("inside th Tag Name")
        let tagName = this.selectedTagArray
        let res = await this.act_log_management_details_tag_name(tagName)
          console.log(res)
      }else if(this.selectedApplicationArray.length != 0){
          console.log("inside th Tag Name")
        let applicationName = this.selectedApplicationArray
        let res = await this.act_log_management_Details_Application_Name(applicationName)
        console.log(res)
      }else if(this.DateValue){
         console.log(this.DateValue)
         let res = await this.act_log_management_details_date(this.DateValue)
         console.log(res)
         if(res.status){
          this.tableData=[]
          this.tableData = res.data.data
         }
      }
      }catch(err){
        console.log(err)
      }
    },
    async fetchLogManahementDetails(){
       try{
        let payload={
          tagName:"",
          logStatus:"",
          logMessage:"",
          logType:"",
          date:"",
          applicationName:""
        }
        console.log(payload)
         let res = await this.act_log_management_Details()
       
         this.tableData = res.data.data
        //  for(let data of this.tableData ){
        //   console.log(data.exceptionLog.logMessage)
        //  }
        
       }catch(err){
        console.log(err)
       }
    },
    async fetchLogManahementApplicationDetails(){
       try{
         let res = await this.act_log_management_Application_Details()
         this.applicationName=res.data.data[0].applicationNames
         this.applicvationTagName = res.data.data[0].tagNames
       }catch(err){
        console.log(err)
       }
    },
    popUpWindowFunction(value){
      this.popUpWindow = true
      this.PopUpheader = value
    }
  },
  goToSummary(){
    console.log(this.openDropDown)
    this.openDropDown == false ? true :false ;
    console.log(this.openDropDown)
  }
};
</script>
<style lang="scss" scoped>
.logsheetHeader {
  width: 100%;
  height: 80px;
  border-bottom: solid 2px lavender;
  display: flex;
}
p{
  max-height:20px;
  overflow: hidden;
}
.icon-profile {
  height: 40px;
  width: 40px;
}
.headerContent {
  width: 90%;
  border-right: 2px solid rgb(216, 216, 237);
  display: flex;
  align-items: center;
  color: #34c0be;
  text-shadow: 4px 4px 10px rgb(137, 244, 244);
  font-size: xx-large;
  font-weight: bolder;
  font-family: "Times New Roman";
  padding-left: 40px;
}
.img-user-account {
  width: 33px;
  height: 33px;
  object-fit: contain;
}
.headerLogo {
  display: flex;
  align-items: center;
}
.logsheetSideNav {
  width: 20%;
  min-height:875px;
  max-height: 100%;
  background-color: rgb(246, 249, 249);
  ul {
    list-style: none;
    li {
      padding: 10px;
      padding-left: 25px;
    }
  }
}
.logsheetBody {
  position:relative;
  height:100%;
  display: flex;
}

.listHeader {
  color: blue;
  background-color: rgb(219, 221, 221);
  padding: 10px;
}
.listHeaderLogType{
  margin-top: 30px;
  color: blue;
  background-color: rgb(219, 221, 221);
  padding: 10px;
}
.upperContent{
    display: flex;
     gap: 62rem;
    
}
.date-picker{
      padding:20px
     }
.bodyContent{
    margin: 10px;
}
.arrowIcon{
  rotate: 180deg;
  cursor: pointer;
  margin-right: 24px;
  width: 8px;
  height: 12px;
}
.highLightedText{
  font-weight: bold;
}
.verticalLine{
  height: 30px;
  border-left: 2px dotted rgb(44, 215, 218);
  margin:5px 0px
}
.selctionNav{
  margin:0px 50px;
  font-size:larger;
}
.headerLabel{
  margin:20px 0px;
  
}
.headerLabelActive{
  margin:20px 0px;
  font-weight: bold;
}
input{
    margin-right:10px;
  }
  .arrowDropDown{
     rotate:270deg;
     margin-left: 5px;
  }
  .button{
    margin-left: 50px;
  }
</style>
